import { Card, Button, Flex, Heading, Icon, View } from "@aws-amplify/ui-react";

export default function CareGroupCard({title, onViewClick, onEditClick, onDeleteClick, showView = true, showEdit = true, showDelete = true}) {
  return (
    <Card>
      <Flex direction="row" justifyContent="flex-start" alignItems="center">
        <View
          width="80px"
          height="80px"
          position="relative"
        >
          <Icon
            width="80px"
            height="80px"
            viewBox={{ minX: 0, minY: 0, width: 80, height: 80 }}
            paths={[
              {
                d: "M0 40C0 17.9121 17.9121 0 40 0C62.0879 0 80 17.9121 80 40C80 62.0879 62.0879 80 40 80C17.9121 80 0 62.0879 0 40Z",
                fill: "rgba(4,125,149,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="0%"
            left="0%"
            right="0%"
          ></Icon>
          <View
            padding="0px 0px 0px 0px"
            width="45.51px"
            height="31.83px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="30.77%"
            bottom="29.44%"
            left="26.18%"
            right="16.93%"
          >
            <View
              padding="0px 0px 0px 0px"
              width="36.59px"
              height="31.37px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="1.42%"
              bottom="0%"
              left="0%"
              right="19.6%"
            >
              <Icon
                width="11.58px"
                height="31.37px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 11.582206726074219,
                  height: 31.37444496154785,
                }}
                paths={[
                  {
                    d: "M5.60612 5.96534C7.10551 5.96534 8.65328 4.54655 8.65328 3.03104C8.65328 1.53164 7.18613 0 5.68673 0C4.18734 0 2.68794 1.56389 2.68794 3.0794C2.67182 4.5788 4.0906 5.96534 5.60612 5.96534ZM11.5392 10.1733C11.5392 8.69005 11.6359 8.83515 11.5392 7.91616C11.1684 6.78759 10.4106 6.41677 9.65287 6.41677C8.04062 6.41677 7.50858 6.41677 6.26714 6.41677C4.75163 6.41677 4.02611 6.41677 2.5106 6.41677C1.75284 6.41677 1.26916 6.3684 0.704871 6.8682C-0.0528882 7.72269 0.0116038 7.8033 0.0116038 10.2217C0.0116038 11.4148 0.0116038 13.4946 0.0116038 14.8166C0.0116038 16.0097 -0.181869 17.8638 1.0112 17.8638C2.13977 17.8638 2.12366 17.0576 2.12366 15.8484C2.12366 14.1556 2.12366 13.7042 2.12366 12.7046C2.12366 11.6082 2.05917 11.4148 2.28488 11.4148C2.5106 11.4148 2.5106 11.4309 2.5106 12.5917C2.5106 13.6719 2.49447 28.8755 2.49447 29.7461C2.49447 30.5038 2.89754 31.31 4.02611 31.31C5.15469 31.31 5.62224 30.6489 5.62224 29.8912C5.62224 28.5369 5.62224 22.6199 5.62224 21.975C5.62224 21.2172 5.65449 20.8626 5.83184 20.8626C6.02531 20.8626 5.99306 21.2334 5.99306 21.975C5.99306 22.6522 5.99306 28.4885 5.99306 29.8912C5.99306 30.3587 6.49286 31.3744 7.62144 31.3744C8.37919 31.3744 9.07246 30.4071 9.07246 29.9073C9.07246 26.8924 9.08859 13.4946 9.08859 12.5433C9.08859 12.0274 9.04022 11.3825 9.23369 11.3825C9.42716 11.3825 9.42716 11.5599 9.42716 12.3015C9.42716 13.156 9.42716 14.0105 9.42716 15.2035C9.42716 17.1866 9.73349 17.7025 10.4912 17.7025C11.6198 17.7025 11.5231 15.7678 11.5231 14.6876C11.5392 13.2205 11.5392 11.6727 11.5392 10.1733Z",
                    fill: "rgba(255,255,255,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0%"
                bottom="0%"
                left="68.35%"
                right="0%"
              ></Icon>
              <Icon
                width="11.58px"
                height="31.37px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 11.582446098327637,
                  height: 31.37444496154785,
                }}
                paths={[
                  {
                    d: "M5.60636 5.96534C7.10576 5.96534 8.65352 4.54655 8.65352 3.03104C8.65352 1.53164 7.18637 0 5.68697 0C4.18758 0 2.68818 1.56389 2.68818 3.0794C2.68818 4.5788 4.10697 5.96534 5.60636 5.96534ZM11.5395 10.1733C11.5395 8.69005 11.6362 8.83515 11.5395 7.91616C11.1686 6.78759 10.4109 6.41677 9.65311 6.41677C8.04086 6.41677 7.50882 6.41677 6.26739 6.41677C4.75187 6.41677 4.02635 6.41677 2.51084 6.41677C1.75308 6.41677 1.2694 6.3684 0.705113 6.8682C-0.0526459 7.72269 0.0118437 7.8033 0.0118437 10.2217C0.0118437 11.4148 0.0118437 13.4946 0.0118437 14.8166C0.0118437 16.0097 -0.181626 17.8638 0.995319 17.8638C2.1239 17.8638 2.1239 17.0576 2.1239 15.8484C2.1239 14.1556 2.1239 13.7042 2.1239 12.7046C2.1239 11.6082 2.05941 11.4148 2.28512 11.4148C2.51084 11.4148 2.51084 11.4309 2.51084 12.5917C2.51084 13.6719 2.49471 28.8755 2.49471 29.7461C2.49471 30.5038 2.89778 31.31 4.02635 31.31C5.15493 31.31 5.62248 30.6489 5.62248 29.8912C5.62248 28.5369 5.62248 22.6199 5.62248 21.975C5.62248 21.2172 5.65473 20.8626 5.83208 20.8626C6.02555 20.8626 5.9933 21.2334 5.9933 21.975C5.9933 22.6522 5.9933 28.4885 5.9933 29.8912C5.9933 30.3587 6.4931 31.3744 7.62168 31.3744C8.37944 31.3744 9.07271 30.4071 9.07271 29.9073C9.07271 26.8924 9.08883 13.4946 9.08883 12.5433C9.08883 12.0274 9.04046 11.3825 9.23393 11.3825C9.4274 11.3825 9.4274 11.5599 9.4274 12.3015C9.4274 13.156 9.4274 14.0105 9.4274 15.2035C9.4274 17.1866 9.73373 17.7025 10.4915 17.7025C11.6201 17.7025 11.5233 15.7678 11.5233 14.6876C11.5395 13.2205 11.5395 11.6727 11.5395 10.1733Z",
                    fill: "rgba(255,255,255,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0%"
                bottom="0%"
                left="34.15%"
                right="34.19%"
              ></Icon>
              <Icon
                width="11.58px"
                height="31.37px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 11.584771156311035,
                  height: 31.37444496154785,
                }}
                paths={[
                  {
                    d: "M5.60869 5.96534C7.10808 5.96534 8.65585 4.54655 8.65585 3.03104C8.65585 1.53164 7.18869 0 5.6893 0C4.1899 0 2.69051 1.56389 2.69051 3.0794C2.67439 4.5788 4.09317 5.96534 5.60869 5.96534ZM11.5418 10.1733C11.5418 8.69005 11.6385 8.83515 11.5418 7.91616C11.171 6.78759 10.4132 6.41677 9.65544 6.41677C8.04319 6.41677 7.51115 6.41677 6.26971 6.41677C4.75419 6.41677 4.02868 6.41677 2.51316 6.41677C1.7554 6.41677 1.27173 6.3684 0.707438 6.8682C-0.0503213 7.72269 0.0141683 7.8033 0.0141683 10.2217C0.0141683 11.4148 0.0141683 13.4946 0.0141683 14.8166C0.0141683 16.0097 -0.195424 17.8638 0.997644 17.8638C2.12622 17.8638 2.12622 17.0576 2.12622 15.8484C2.12622 14.1556 2.12622 13.7042 2.12622 12.7046C2.12622 11.6082 2.06173 11.4148 2.28745 11.4148C2.51316 11.4148 2.51316 11.4309 2.51316 12.5917C2.51316 13.6719 2.49704 28.8755 2.49704 29.7461C2.49704 30.5038 2.9001 31.31 4.02868 31.31C5.15725 31.31 5.64093 30.6489 5.64093 29.8912C5.64093 28.5369 5.64093 22.6199 5.64093 21.975C5.64093 21.2172 5.67318 20.8626 5.85052 20.8626C6.04399 20.8626 6.01175 21.2334 6.01175 21.975C6.01175 22.6522 6.01175 28.4885 6.01175 29.8912C6.01175 30.3587 6.51155 31.3744 7.64013 31.3744C8.39788 31.3744 9.09115 30.4071 9.09115 29.9073C9.09115 26.8924 9.10727 13.4946 9.10727 12.5433C9.10727 12.0274 9.05891 11.3825 9.25238 11.3825C9.44585 11.3825 9.44585 11.5599 9.44585 12.3015C9.44585 13.156 9.44585 14.0105 9.44585 15.2035C9.44585 17.1866 9.75218 17.7025 10.5099 17.7025C11.6385 17.7025 11.5418 15.7678 11.5418 14.6876C11.5418 13.2205 11.5418 11.6727 11.5418 10.1733Z",
                    fill: "rgba(255,255,255,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0%"
                bottom="0%"
                left="0%"
                right="68.34%"
              ></Icon>
            </View>
            <Icon
              width="8.43px"
              height="8.43px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 8.432085990905762,
                height: 8.432084083557129,
              }}
              paths={[
                {
                  d: "M6.93269 2.74083C7.35187 2.74083 7.70657 2.88593 7.99678 3.16002C8.28698 3.4341 8.43209 3.7888 8.43209 4.20798C8.43209 4.61104 8.28698 4.96574 7.99678 5.23982C7.70657 5.53003 7.35187 5.67513 6.93269 5.67513L5.67513 5.67513L5.67513 6.93269C5.67513 7.35187 5.53003 7.70657 5.23982 7.99678C4.94962 8.28698 4.61104 8.43208 4.19186 8.43208C3.77267 8.43208 3.41798 8.28698 3.14389 7.99678C2.86981 7.70657 2.72471 7.35187 2.72471 6.93269L2.72471 5.67513L1.45103 5.67513C1.03184 5.67513 0.69327 5.53003 0.419187 5.23982C0.145104 4.94962 0 4.61104 0 4.20798C0 3.7888 0.145104 3.4341 0.419187 3.16002C0.69327 2.88593 1.03184 2.74083 1.45103 2.74083L2.72471 2.74083L2.72471 1.46715C2.72471 1.04797 2.86981 0.69327 3.14389 0.419187C3.41798 0.145104 3.77267 0 4.19186 0C4.59492 0 4.94962 0.145104 5.23982 0.419187C5.53003 0.69327 5.67513 1.04797 5.67513 1.46715L5.67513 2.74083L6.93269 2.74083Z",
                  fill: "rgba(255,255,255,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="73.51%"
              left="81.47%"
              right="0%"
            ></Icon>
          </View>
        </View>
        <Flex
          gap="10px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="10px 10px 10px 10px"
        >
          <Heading
            level="4"
            children={title}
          ></Heading>
          <Flex
            gap="10px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="10px 10px 10px 10px"
          >
            <Button size="small" variation="primary" children="View" onClick={onViewClick} display={showView ? '' : 'none'} />
            <Button size="small" variation="primary" children="Edit" onClick={onEditClick} display={showEdit ? '' : 'none'}/>
            <Button size="small" variation="destructive" children="Delete" onClick={onDeleteClick} display={showDelete ? '' : 'none'}/>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
